module.exports = __webpack_public_path__ + "img/160x41_Get_Shockwave.7fe7ce7f.jpg";